export default __webpack_public_path__ + "static/media/portfolio-207.68ee55ff.jpg";